import React from "react"
import { MainCP } from "../../Components/desempeno-politico/MainCP"


const ViewDesempeno: React.FC = () => <MainCP/>
 

export default ViewDesempeno;


      


